var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"btnrow"},[_c('el-row',{staticClass:"swtichBtn"},[_c('el-col',{attrs:{"span":0}}),_c('el-col',{staticClass:"tagrowBtn",attrs:{"span":24}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }